<template>
  <div :style="{width:width+'px',height:height+'px',backgroundColor:'rgba(0,0,0,0.8)'}">
    <div class="text-r p-r-30" style="background-color:rgba(0,0,0,0.3);line-height:50px">
      <span @click=" rotate==3 ? rotate =0 : rotate++">
        <Icon class="c-white c-h m-r-10" size="20" type="ios-refresh-circle-outline"/>
      </span>
      <span @click="type = 'tubo_medium'">
        <Icon class="c-white c-h m-r-10" size="20" type="ios-remove-circle-outline"/>
      </span>
      <span @click="type = 'tubo_large'">
        <Icon class="c-white c-h m-r-10" size="20" type="ios-add-circle-outline"/>
      </span>
      <span @click="close">
        <Icon class="c-white c-h" size="20" type="ios-close-circle-outline"></Icon>
      </span>
    </div>
    <Carousel :value="index" :height="height-60">
      <CarouselItem v-for="(item,index) in images" :key="index" class="tb-column-center">
        <div class="images_preview" style="overflow:auto;width:100%">
          <img :class="{images_rotate_90:rotate==1,images_rotate_180:rotate==2,images_rotate_270:rotate==3}"
               :src="item.url">
        </div>
      </CarouselItem>
    </Carousel>
  </div>
</template>
<script>
  import iView from "iview";
  import Vue from "vue";

  export default {
    data() {
      return {
        rotate: 0,
        type: "tubo_medium",
        init: Vue.filter("img_oss"),
        height: window.innerHeight,
        width: window.innerWidth
      };
    },
    props: ["item", 'list'],
    computed: {
      images() {
        const images = typeof this.$props.list == 'object' ? this.$props.list : this.$props.list()
        return images.map(item => {
          return {name: item, url: this.init(item, this.type)};
        });
      },
      index() {
        const images = typeof this.$props.list == 'object' ? this.$props.list : this.$props.list()
        return images.indexOf(this.$props.item)
      }
    },
    methods: {
      close() {
        iView.Spin.hide();
      }
    }
  };
</script>
<style scoped>
  .images_rotate_90 {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
  }

  .images_rotate_180 {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -o-transform: rotate(180deg);
  }

  .images_rotate_270 {
    transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
    -o-transform: rotate(270deg);
  }

  .images_preview {
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-divor: #f5f5f5;
  }

  /*定义滚动条轨道 内阴影+圆角*/

  ::-webkit-scrollbar-track {
    display: none;
  }

  /*定义滑块 内阴影+圆角*/

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 2px rgba(255, 255, 255, 0.8);
    background-divor: #f2f2f2;
  }
</style>
